module.exports = __webpack_public_path__ + "biao15.jpg?dde037a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao15.jpg
 ** module id = 50
 ** module chunks = 0
 **/